import React from 'react'
import ReportForm from '../../components/Report/ReportForm'

const reports = () => {
  return (
    <>
    
    <div className='mx-[-30px] md:mx-0 mb-[49px]'>
     <p style={ {fontWeight: 700} } className=''>Reports</p> 
    </div>

    <div className='lg:mt-[117px]  md:bg-[#fff] min-h-screen  mx-[-30px] md:mx-[64px] lg:mx-0 '>
     
      <div className='pt-[20px] md:pl-[50px] lg:pl-[64px] lg:pt-[55px] pb-[22px]'>
        <h1 style={ {fontWeight: 600} } className='lg:text-[20px] text-[#000] whitespace-nowrap'>Generate Report</h1>
       <p className='whitespace-wrap 360:whitespace-nowrap'>Select a report type for a particular period</p>
      </div> 

        <hr/>

       <ReportForm/>

    </div>
    </>
    
  )
}

export default reports